'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002eruntime$002e$002dTuples$0024 from "./scala.runtime.-Tuples$.js";
var $p;
/** @constructor */
function $c_T$() {
}
export { $c_T$ as $c_T$ };
$p = $c_T$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T$;
/** @constructor */
function $h_T$() {
}
export { $h_T$ as $h_T$ };
$h_T$.prototype = $p;
$p.Uj = (function(xs) {
  var $x_13 = $j_scala$002eruntime$002e$002dTuples$0024.$m_sr_Tuples$();
  if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_O)) {
    var $x_1 = xs;
  } else {
    var f = ((_$10$2) => _$10$2);
    $j_java$002elang$002e$002dObject.$m_s_reflect_ManifestFactory$ObjectManifest$();
    var len = $j_java$002elang$002e$002dObject.$m_jl_reflect_Array$().aB(xs);
    var ys = new $j_java$002elang$002e$002dObject.$ac_O(len);
    if ((len > 0)) {
      var i = 0;
      if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_O)) {
        while ((i < len)) {
          var $x_2 = i;
          var x0 = xs.a[i];
          ys.a[$x_2] = f(x0);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_I)) {
        while ((i < len)) {
          var $x_3 = i;
          var x0$1 = xs.a[i];
          ys.a[$x_3] = f(x0$1);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_D)) {
        while ((i < len)) {
          var $x_4 = i;
          var x0$2 = xs.a[i];
          ys.a[$x_4] = f(x0$2);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_J)) {
        while ((i < len)) {
          var $x_7 = i;
          var $x_5 = xs.a;
          var $x_6 = (i << 1);
          var x0$3_$_lo = $x_5[$x_6];
          var x0$3_$_hi = $x_5[(($x_6 + 1) | 0)];
          ys.a[$x_7] = f($j_java$002elang$002e$002dObject.$bL(x0$3_$_lo, x0$3_$_hi));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_F)) {
        while ((i < len)) {
          var $x_8 = i;
          var x0$4 = xs.a[i];
          ys.a[$x_8] = f(x0$4);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_C)) {
        while ((i < len)) {
          var $x_9 = i;
          var x0$5 = xs.a[i];
          ys.a[$x_9] = f($j_java$002elang$002e$002dObject.$bC(x0$5));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_B)) {
        while ((i < len)) {
          var $x_10 = i;
          var x0$6 = xs.a[i];
          ys.a[$x_10] = f(x0$6);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_S)) {
        while ((i < len)) {
          var $x_11 = i;
          var x0$7 = xs.a[i];
          ys.a[$x_11] = f(x0$7);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_Z)) {
        while ((i < len)) {
          var $x_12 = i;
          var x0$8 = xs.a[i];
          ys.a[$x_12] = f(x0$8);
          i = ((1 + i) | 0);
        }
      } else {
        throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(xs);
      }
    }
    var $x_1 = ys;
  }
  return $x_13.Uk($x_1);
});
var $d_T$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T$, "scala.Tuple$", ({
  s5: 1,
  e: 1,
  aa: 1
}));
export { $d_T$ as $d_T$ };
var $n_T$;
function $m_T$() {
  if ((!$n_T$)) {
    $n_T$ = new $c_T$();
  }
  return $n_T$;
}
export { $m_T$ as $m_T$ };
